<template>
  <div class="header-layout">
    <div class="navigation-bar" :class="{'white-background': scrollTop > 0}">
      <div class="navigation">
        <div class="left">
          <div class="logo" @click="goHome">
            <img v-if="scrollTop" src="@/assets/imgs/layout/logo-header.png" alt="">
            <img v-else src="@/assets/imgs/home/kkpar-logo-white.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        scrollTop: 0
      }
    },
    methods: {
      goHome() {
        this.$router.push('/')
      }
    }
  }
</script>

<style lang="less" scoped>
  .header-layout {
    .navigation-bar {
      background: linear-gradient(90deg, #00C1CB 0%, #4880FF 124.47%);
      width: 100%;
      max-width: 100%;
      position: fixed;
      top: 0;
      z-index: 100;
    }
    .navigation {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px var(--kk-spacing-10);
      color: #fff;
      margin: 0 auto;
      .logo {
        width: 177px;
        height: 35px;
        margin-right: var(--kk-spacing-10);
        cursor: pointer;
        img {
          width: 177px;
          height: 35px;
        }
      }
      .left, .right {
        display: flex;
        align-items: center;
        a {
          text-decoration: none;
          color: #fff;
        }
        .el-dropdown {
          color: #fff;
          font-size: unset;
        }
        .item {
          padding: var(--kk-spacing-3) var(--kk-spacing-7);
        }
        .login-btn {
          border: 1.5px solid #fff;
          border-radius: var(--kk-radius-lg);
          padding: var(--kk-spacing-4) var(--kk-spacing-6);
          box-sizing: border-box;
          margin-left: var(--kk-spacing-5);
        }
      }
      .right {
        .item {
          cursor: pointer;
        }
      }
    }
    .white-background {
      background: #fff;
      .navigation {
        color: var(--kk-color-text-darker);
        a {
          color: var(--kk-color-text-darker);
          &:hover {
            color: var(--kk-color-text-primary-medium);
          }
        }
        .login-btn {
          color: var(--kk-color-text-primary-medium);
          border-color: var(--kk-color-text-primary-medium);
        }
      }
    }
  }
  @media screen and (min-width: 1200px) {
    .navigation, .main, .cards, .platform, .help {
      max-width: 1200px;
      width: 1200px;
    }
    .top {
      .main {
        .left {
          padding: 63px 82px;

        }
        .right {
          padding: var(--kk-spacing-3) var(--kk-spacing-5);
        }
      }
    }
  }
</style>
